import { Component, ViewEncapsulation, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { VraagboomEmptyResultaat } from '@models/vragenboom';
import { Antwoord, Vraag } from '@models/claims';
import { DataService } from '@components/public_api';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class InfoComponent extends BaseVraagControlDirective<VraagboomEmptyResultaat> implements OnInit, OnChanges {
  resultaat: VraagboomEmptyResultaat = new VraagboomEmptyResultaat();

  constructor(_dataService: DataService) {
    super(_dataService);
  }

  ngOnInit() {
    this.notifyAntwoord();
  }

  initialize(changes: SimpleChanges): void {
  }

  notifyAntwoord() {
    const antwoorden: Antwoord[] = [];
    if (this.vraag && this.vraag.antwoorden && this.vraag.antwoorden.length > 0) {
      antwoorden.push(this.vraag.antwoorden[0]);
    }

    this.setAntwoord(antwoorden, this.resultaat);
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomEmptyResultaat): boolean {
    return true;
  }
}
